import type { GetLemaSalesPersonsResponse } from "@/app/api/lema-sales-persons/route";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";
import { getLemaSalesPersonsRequestSchema } from "@/lib/schemas/cat/lema-sales-persons-request";

const LEMA_SALES_PERSONS_ENDPOINT = "/api/lema-sales-persons";

export const invalidateLemaSalesPersonsQuery = createInvalidateQuery(
  LEMA_SALES_PERSONS_ENDPOINT,
);

export const useLemaSalesPersonsQuery =
  createQueryHook<GetLemaSalesPersonsResponse>(
    LEMA_SALES_PERSONS_ENDPOINT,
    getLemaSalesPersonsRequestSchema,
  );
